// extracted by mini-css-extract-plugin
export default {"root":"styles_root__HoTVP","textBlock":"styles_textBlock__+a1X1","firstLine":"styles_firstLine__GRrXK","secondLine":"styles_secondLine__1TUm9"};